import React from "react";

import { RequireAuth } from "../components/auth/RequireAuth";
import ThemeContainer, { Theme } from "../components/common/ThemeContainer";
import { Analytics } from "../components/queues/Analytics";
import { Home as HomeComponent } from "../components/queues/App/Home";
import QueueComponent from "../components/queues/App/Queue";
import AssignedQueue from "../components/queues/App/Queue/AssignedQueue";
import { Config } from "../components/queues/Config";
import { Layout, PaddedLayout } from "../layouts";

import { AccountLockedGate } from "./errors";

export const Home = () => {
  return (
    <RequireAuth>
      <ThemeContainer theme={Theme.Default}>
        <Layout>
          <AccountLockedGate>
            <HomeComponent />
          </AccountLockedGate>
        </Layout>
      </ThemeContainer>
    </RequireAuth>
  );
};

export const NewQueue = () => {
  return (
    <RequireAuth>
      <ThemeContainer theme={Theme.Default}>
        <PaddedLayout>
          <AccountLockedGate>
            <Config />
          </AccountLockedGate>
        </PaddedLayout>
      </ThemeContainer>
    </RequireAuth>
  );
};

export const EditQueue = () => {
  return (
    <RequireAuth>
      <ThemeContainer theme={Theme.Default}>
        <PaddedLayout>
          <AccountLockedGate>
            <Config />
          </AccountLockedGate>
        </PaddedLayout>
      </ThemeContainer>
    </RequireAuth>
  );
};

export const Queue = () => {
  return (
    <RequireAuth>
      <ThemeContainer theme={Theme.Default}>
        <Layout>
          <AccountLockedGate>
            <QueueComponent />
          </AccountLockedGate>
        </Layout>
      </ThemeContainer>
    </RequireAuth>
  );
};

export const Assigned = () => {
  return (
    <RequireAuth>
      <ThemeContainer theme={Theme.Default}>
        <Layout>
          <AccountLockedGate>
            <AssignedQueue />
          </AccountLockedGate>
        </Layout>
      </ThemeContainer>
    </RequireAuth>
  );
};

export const QueueAnalytics = () => {
  return (
    <RequireAuth>
      <ThemeContainer theme={Theme.Default}>
        <Layout>
          <AccountLockedGate>
            <Analytics />
          </AccountLockedGate>
        </Layout>
      </ThemeContainer>
    </RequireAuth>
  );
};
